<template>
  <div class="main-content">
    <van-nav-bar
      id="titlebar"
      title="我审批的"
      left-arrow
      @click-left="onClickLeft"
    >
    </van-nav-bar>
    <div class="content">
      <van-tabs
        v-model:active="active"
        @change="handleTabChange"
        border
        line-width="40%"
        line-height="2"
        style="height: 100%"
      >
        <van-tab title="待处理" style="height: 100%">
          <item-view :type="0" @on-click-item="handleApprove" />
        </van-tab>
        <van-tab title="已处理" style="height: 100%">
          <item-view :type="1" />
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useRouter } from "vue-router";
import itemView from "./item.vue";
import { getApproveList } from "@/api/sign";

const router = useRouter();
const active = ref(0);
const unProcessList: any = ref([]);
const approveList: any = ref([]);

const handleTabChange = (_name, _title) => {};

const handleApprove = (item: any) => {
  // 跳转到审批页面 (待处理)
  router.push({
    name: "approveinfo",
    params: { signId: item.signInId },
  });
};

const onClickLeft = () => {
  window?.flutter_inappwebview?.callHandler("goBackToApp", null);
};

onMounted(() => {
  getApproveList({ signStatus: 0 })
    .then((res) => {
      if (res) {
        unProcessList.value = res;
      }
    })
    .catch(() => {
      showFailToast("网络异常");
    });

  getApproveList({ signStatus: 1 })
    .then((res) => {
      if (res) {
        approveList.value = res;
      }
    })
    .catch(() => {
      showFailToast("网络异常");
    });
});
</script>
<style scoped>
.main-content {
  width: 100%;
  height: calc(100% - 50px);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  font-size: 14px;
  overflow: hidden;
}

.content {
  flex: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #fff;
}
.list {
  width: 100%;
  height: 100%;
}
</style>
